'use strict';

/**
 * @classname CrossfadeSlideshow
 * @classdesc KVとFooter画像のクロスフェードスライドショー
 */
export default class CrossfadeSlideshow {
	/**
	 * @constructor
	 * @param {jQuery} $e - .block--kv__bg / .block--footer-bg
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$photos = $e.find('.image--kv-bg, .image--footer-bg');
		this._index = 0;
		this._intervalMs = 4000;
		this._transitionMs = 1500;
		this._isTransitioning = false;
		this._timer = null;
		this._isVisible = !('IntersectionObserver' in window);

		if (this._$photos.length < 2) return;
		this._$photos.each((idx, photo) => {
			const $photo = $(photo);
			$photo.attr('data-slideshow-src', $photo.attr('data-src') || $photo.attr('src'));
			// picture内のSP用sourceも、imgと同じタイミングで読み込み・解放する
			const $source = $photo.siblings('source');
			if ($source.length) {
				$source.attr('data-slideshow-srcset', $source.attr('data-srcset') || $source.attr('srcset'));
			}
		});
		document.addEventListener('visibilitychange', () => this.updatePlayback());
		if ('IntersectionObserver' in window) {
			// 止めているフッターも表示位置の手前で準備する。既存のimg/lazyは維持。
			const preloadObserver = new IntersectionObserver((entries) => {
				if (!entries.some((entry) => entry.isIntersecting)) return;
				preloadObserver.disconnect();
				this.preload();
			}, { rootMargin: '1600px 0px' });
			preloadObserver.observe($e[0]);
			this._observer = new IntersectionObserver((entries) => {
				this._isVisible = entries.some((entry) => entry.isIntersecting);
				this.updatePlayback();
			});
			this._observer.observe($e[0]);
		}
		this.updatePlayback();
	};

	preload() {
		this.load(this._$photos.eq(this._index));
		this.load(this._$photos.eq((this._index + 1) % this._$photos.length));
	}

	updatePlayback() {
		if (this._isVisible && !document.hidden) {
			if (this._timer !== null) return;
			this.preload();
			this._timer = setInterval(() => this.next(), this._intervalMs);
		} else {
			clearInterval(this._timer);
			this._timer = null;
		}
	}

	async load($photo) {
		const photo = $photo.get(0);
		const src = $photo.attr('data-slideshow-src');

		if (!photo || !src) return false;
		// JSが必要と判断した写真はnative lazyの判定待ちにしない。
		photo.loading = 'eager';
		const $source = $photo.siblings('source');
		const srcset = $source.attr('data-slideshow-srcset');
		if (srcset && $source.attr('srcset') !== srcset) $source.attr('srcset', srcset);
		if ($photo.attr('src') !== src) $photo.attr('src', src);
		if (!photo.complete) {
			await new Promise((resolve) => {
				$photo.one('load error', resolve);
			});
		}
		if (!photo.naturalWidth) return false;
		try {
			if (typeof photo.decode === 'function') await photo.decode();
			return true;
		} catch (error) {
			return false;
		}
	}

	/**
	 * 次の画像へクロスフェード
	 *
	 * @memberof CrossfadeSlideshow
	 * @return undefined
	 */
	async next() {
		if (this._isTransitioning || !this._isVisible || document.hidden) return;
		this._isTransitioning = true;

		const previousIndex = this._index;
		const nextIndex = (previousIndex + 1) % this._$photos.length;
		const preloadIndex = (nextIndex + 1) % this._$photos.length;
		const $previous = this._$photos.eq(previousIndex);
		const $next = this._$photos.eq(nextIndex);

		const isReady = await this.load($next);
		// 通信失敗・デコード待ち・画面外では現在の写真を消さない。
		if (!isReady || !this._isVisible || document.hidden) {
			this._isTransitioning = false;
			return;
		}
		$previous.removeClass('is-active');
		$next.addClass('is-active');
		this._index = nextIndex;

		setTimeout(() => {
			if (previousIndex !== this._index) {
				$previous.removeAttr('src');
				$previous.siblings('source').removeAttr('srcset');
			}
			if (this._isVisible && !document.hidden) this.load(this._$photos.eq(preloadIndex));
			this._isTransitioning = false;
		}, this._transitionMs);
	}
};
